import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  CertificatesListParams,
  CertificatesListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CERTIFICATES_LIST_QUERY_KEY = 'certificates_list';
export const RECEIPT_QUERY_KEY = 'receipt';

export const useCertificatesListQuery = (
  url: string,
  queryParams: CertificatesListParams['queryParams'],
) =>
  useQuery({
    queryKey: [CERTIFICATES_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<CertificatesListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

export const useReceiptQuery = (receiptUrl?: string) =>
  useQuery({
    queryKey: [RECEIPT_QUERY_KEY, receiptUrl],
    queryFn: () =>
      HttpClient.request<string>({
        method: 'GET',
        url: receiptUrl,
        headers: { Accept: 'text/html' },
        responseType: 'text',
      }),
    enabled: !!receiptUrl,
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
  });
